import { GChartTooltipProps } from './types'

export const GChartTooltip = ({
	title,
	items,
	className,
	titleClassName,
	itemClassName
}: GChartTooltipProps) => {
	return (
		<div
			data-theme="light"
			className={`bg-white text-t-default shadow-lg px-4 py-2 rounded-lg border text-sm max-w-lg whitespace-normal ${
				className || ''
			}`}
		>
			{title && (
				<div className={`font-bold mb-2 text-sm ${titleClassName || ''}`}>
					{title}
				</div>
			)}
			{items.map((item, index) => (
				<div
					key={item.key || index}
					className={`flex items-center justify-between gap-2 mb-1 ${
						itemClassName || ''
					}`}
				>
					<div className="flex items-center gap-2">
						{item.color && (
							<div
								className="w-2 h-2 rounded-full"
								style={{ backgroundColor: item.color }}
							/>
						)}
						<span className="text-xs text-gray-600">{item.label}:</span>
					</div>
					<span className="text-xs font-medium">{item.value}</span>
				</div>
			))}
		</div>
	)
}
